import React from 'react';
import PropTypes from 'prop-types';

import {
  StyledBoxNotification,
  StyledTitleNotification,
  StyledIconArrow,
  StyledIconCollapseNot
} from './style';

import {
  StyledEvent,
  FirstElementEvent,
  StyledIcons,
  StyledLayer,
  StyledLayerShort,
  StyledLayerRight,
  StyledName,
  StyledCity,
  StyledDayHours,
  StyledCourse,
  StyledBoxInterior,
  StyledBoxInteriorButtonMessage,
  StyledIconOk,
  StyledText,
  ButtonsEvent,
  StyledCheck,
  StyledBoxDown,
  StyledLink,
  StyledIconCollapseDown,
  StyledTag,
  StyledPrice
} from './styleEvent';

import { Back, Ok, Colapse, Viajes } from '../../../../assets/images/index';

import { Paginator } from '../Paginator';
import Icon from '../Icon';

const TravelNotifications = ({ className, title, dataTravel }) => {
  const eventTravel = item => (
    <StyledEvent acceptedEvent={item.accepted} tabIndex="0">
      <FirstElementEvent>
        <StyledIcons
          size="m"
          color={item.accepted ? 'grayDarker' : 'light'}
          svg={Viajes}
        />
        <StyledLayerShort>
          <StyledName>{item.name}</StyledName>
          <StyledCourse>{item.course}</StyledCourse>
          <StyledIconCollapseDown color="primary" size="s" svg={Colapse} />
        </StyledLayerShort>
      </FirstElementEvent>
      <StyledLayer>
        <StyledCity>{item.city}</StyledCity>
        <StyledDayHours>{item.date}</StyledDayHours>
      </StyledLayer>
      <StyledLayerRight>
        {item.accepted ? (
          <StyledTag acceptedEvent>Aprobado</StyledTag>
        ) : (
          <StyledTag>Pendiente</StyledTag>
        )}
        <StyledPrice>{item.price}</StyledPrice>
      </StyledLayerRight>
      {item.accepted ? (
        <StyledBoxInterior>
          <StyledIconOk size="m" color="light" svg={Ok} />
          <StyledText>El viaje ha sido autorizado</StyledText>
        </StyledBoxInterior>
      ) : (
        <StyledBoxInteriorButtonMessage>
          <ButtonsEvent ghost>Aceptar</ButtonsEvent>
          <ButtonsEvent ghost>Rechazar</ButtonsEvent>
          <ButtonsEvent ghost>Ver</ButtonsEvent>
          {item.check && (
            <StyledCheck>
              Leído
              <Icon size="s" color="light" svg={Ok} />
            </StyledCheck>
          )}
        </StyledBoxInteriorButtonMessage>
      )}
    </StyledEvent>
  );

  return (
    <StyledBoxNotification className={className}>
      <StyledIconCollapseNot color="main" size="s" svg={Colapse} />
      <StyledTitleNotification>
        <StyledIconArrow size="xs" color="light" svg={Back} /> {title}
      </StyledTitleNotification>

      {dataTravel.map((item, index) => {
        const event = index < 3 && eventTravel(item);
        return event;
      })}

      <StyledBoxDown>
        <StyledLink>Ir a la App</StyledLink>
        {dataTravel.length > 3 && (
          <Paginator pages={dataTravel.length / 3} color="light" />
        )}
      </StyledBoxDown>
    </StyledBoxNotification>
  );
};

TravelNotifications.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  dataTravel: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      course: PropTypes.string,
      city: PropTypes.string,
      date: PropTypes.string,
      price: PropTypes.string,
      accepted: PropTypes.bool,
      check: PropTypes.bool
    })
  )
};

export default TravelNotifications;
